var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('div',{staticClass:"wizard"},_vm._l((_vm.steps),function(item,i){return _c('div',{key:i,on:{"click":function($event){return _vm.changeStep(i)}}},[_c('div',{staticClass:"step"},[_c('div',{class:[
                        'step-box',
                        {
                            active: i == _vm.activeStep,
                            success: i < _vm.activeStep,
                        },
                    ]},[_c('span',[_vm._v(_vm._s(i + 1))])]),(i == _vm.activeStep)?_c('div',{staticClass:"step-desc top"},[_c('p',{staticClass:"name"},[_vm._v(_vm._s(_vm.$t(item)))])]):_vm._e()]),(i == _vm.activeStep)?_c('div',{staticClass:"step-desc bottom"},[_c('p',{staticClass:"name"},[_vm._v(_vm._s(_vm.$t(item)))])]):_vm._e()])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }